import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowCircleDownSvg = function ArrowCircleDownSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 17.677-3.765-3.764 1.048-1.048 1.976 1.976V7.833h1.482v7.008l1.976-1.976 1.047 1.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.071 19.071A10 10 0 1 1 4.93 4.928 10 10 0 0 1 19.07 19.071M12 20.518a8.518 8.518 0 1 0 0-17.036 8.518 8.518 0 0 0 0 17.037",
    clipRule: "evenodd"
  }));
};
export var ArrowCircleDown = function ArrowCircleDown(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ArrowCircleDownSvg
  }));
};